export const REVIEWS = [
  {
    id: "alison",
    client: "Alison Young",
    attribution: "Alison Y, Inverness",
    relation: "Skye's Mum",
    source: "Google review",
    pets: "Skye",
    service: "Pet Sitting",
    text: "Carly is first class and is the best dog sitter/walker in the Highlands! She is just so amazing with my dog Skye and we were so grateful we had her to dog sit her for 9 nights while we were away on holiday. She is so reliable, caring and has a real passion and understanding of dogs and it was a comfort for us that Skye was in good hands with her while we were away. I received daily photos/videos updates of their adventures together. I couldnt recommend Carly enough, and Skye adores hers. We are so delighted Skye will see her again soon for walks and see all her doggy pals on their adventures together.",
    excerpt: "We were so grateful we had Carly to dog sit Skye for 9 nights while we were away on holiday. She is so reliable, caring and has a real passion and understanding of dogs. I received daily photo and video updates of their adventures together. I couldn't recommend Carly enough.",
  },
  {
    id: "rhona",
    client: "Rhona Hearn",
    attribution: "Rhona H, Inverness",
    relation: "Orla's Mum",
    source: "Google review",
    pets: "Orla",
    service: "Dog Walking",
    text: "Carly is amazing with our dog who gets extremely excited when she comes and is clearly very happy after a day with her. She is very professional and sends great updates of all the doggy fun! Lots of flexible options for walking and dog sitting. Would highly recommend",
  },
  {
    id: "yvonne",
    client: "Yvonne Naylor",
    attribution: "Yvonne N, Inverness",
    relation: "Bruno & Boris' Mum",
    source: "Google review",
    pets: "Bruno & Boris",
    service: "Cats & Home Visits",
    text: "Carly is just a total treasure. She looked after our two cats whilst we were on holiday, one of whom is elderly and needs a bit of extra TLC. She sent us regular photos and videos and looked after our boys so well. We came back to two very happy, healthy cats. They obviously adored her. This lady is just solid gold...",
    excerpt: "Carly is just a total treasure. She looked after our two cats whilst we were on holiday, one of whom is elderly and needs a bit of extra TLC. We came back to two very happy, healthy cats. They obviously adored her.",
  },
  {
    id: "christy",
    client: "Christy MacAskill",
    attribution: "Christy M, Inverness",
    relation: "Sonny's Mum",
    source: "Google review",
    pets: "Sonny",
    service: "Pet Sitting",
    text: "Carly looked after our wee 5 month old puppy when we had to go away for a couple of days. We were a bit worried to leave him overnight as we hadn't done this yet, however we needn't have worried! Carly was amazing at keeping us updated and he truly had the best few days of his life at the beach, out for walks with other dogs and truly living his best life with her. I also think our house was cleaner when we came back than when we left! Carly is amazing at what she does and Sonny absolutely loved her. Thank you so much, Carly!",
  },
  {
    id: "roddy",
    client: "Roddy Mackay",
    attribution: "Roddy M, Inverness",
    relation: "Garfield's Dad",
    source: "Google review",
    pets: "Garfield",
    service: "Cats & Home Visits",
    text: "Carly offers a great service, really caring for your pets as if they were her own. I've met her frequently when she has been out walking dogs, she knows a wide range of great spots to explore with your dogs, ensuring that each dog has time to let off steam and get some one on one attention and care. We're a cat family, and Carly kept us updated with pictures of our Orange Tabby for our whole time away. He loves attention, and he got lots!",
  },
  {
    id: "hayley",
    client: "Hayley & Jamie Airey",
    attribution: "Hayley A, Inverness",
    relation: "Poe Poe's Mum",
    source: "Google review",
    pets: "Poe Poe",
    service: "Pet Sitting",
    text: "Carly is absolutely amazing with our dog, and I cannot recommend her highly enough. She has stayed overnight with our dog twice now and we will definitely be booking her again in the future.",
  },
  {
    id: "anya",
    client: "Anya Fraser",
    attribution: "Anya F, Inverness",
    relation: "Jasper & Winnie's Mum",
    source: "Google review",
    pets: "Jasper & Winnie",
    service: "Cats & Home Visits",
    text: "Incredible service from Carly. She's looked after my 2 kitties while away/on holiday, helping them to feel safe and settled at home instead of a cattery. Not only feeding/cleaning up after them but keeping them entertained with play time too, with lots of updates to keep us in the loop. It's great coming home to very happy cats. Would highly recommend Carly for looking after your furry friends.",
  },
  {
    id: "halde",
    client: "Halde Pottinger",
    attribution: "Halde P, Cawdor",
    relation: "Lachie's Dad",
    source: "Facebook review",
    pets: "Lachie",
    service: "Dog Walking",
    text: "Carly has been absolutely fantastic with my dog, Lachie. From the very start, it was clear how natural she is with dogs. Lachie took to her straight away, which says everything. She's reliable, professional, and keeps you updated, which gives real peace of mind. Whether it's walks or general care, you can tell she genuinely loves what she does and treats every dog like her own. I wouldn't hesitate to recommend Carly to anyone looking for someone trustworthy and caring to look after their dog. Lachie is always happy and well looked after, and that's the most important thing.",
  },
  {
    id: "richard",
    client: "Richard Davidson",
    attribution: "Richard D, Inverness",
    relation: "Alfie's Dad",
    source: "Facebook review",
    pets: "Alfie",
    service: "Dog Walking",
    text: "Anyone who knows our pug Alfie knows he's a stubborn wee pug and very picky about people...but Carly had him figured out instantly. Off-lead, confident, tail going, running and absolutely living his best life, and he came home buzzing, which tells you everything. Carly is just one of those cracking people that dogs immediately trust, and it shows. Couldn't recommend her enough. Don't overthink it, just book.",
    excerpt: "Anyone who knows our pug Alfie knows he's a stubborn wee pug and very picky about people... but Carly had him figured out instantly. Off-lead, confident, tail going, absolutely living his best life, and he came home buzzing, which tells you everything.",
  },
  {
    id: "karen",
    client: "Karen Fraser",
    attribution: "Karen F, Inverness",
    relation: "Roxy's Mum",
    source: "Facebook review",
    pets: "Roxy",
    service: "Dog Walking",
    text: "Highly recommend Carly. She is an exceptional dog walker and pet carer. She is experienced in walking dogs of varying breeds and sizes together or solo. She manages the groups calmly and confidently. Our German shepherd Roxy loved her riverside walk with you and i loved the photos you provided and the interaction with the other dogs. The regular photos/videos of every dog are such a thoughtful touch and really show how much care goes into each walk. She also provides a safe caring home from home setting when looking after dogs and cats in their own home.",
  },
  {
    id: "connie",
    client: "Connie Rose",
    attribution: "Connie R, Muir of Ord",
    relation: "Oakley & Hamish's Mum",
    source: "Facebook review",
    pets: "Oakley & Hamish",
    service: "Pet Sitting",
    text: "Carly is fantastic! We used her house sitting service to look after our dogs, ducks and chickens. She was so friendly and professional, excellent at communicating and she kept us up to speed with some lovely photos of our very happy animals while I was away. I would definitely recommend her services and will use them again.",
  },
  {
    id: "georgea",
    client: "Georgea Macleod",
    attribution: "Georgea M, Inverness",
    relation: "Polly's Mum",
    source: "Facebook review",
    pets: "Polly",
    service: "Cats & Home Visits",
    text: "Pollys best pal, now she's getting older and slowing down she loves it when Carly comes and sits with her for an hour and lets her roam the garden and have a sneaky wee treat. So glad to have someone so understanding and reliable.",
  },
  {
    id: "lynsey",
    client: "Lynsey Thane",
    attribution: "Lynsey T, Inverness",
    relation: "Poppy, Nala, Indi & Frans' Mum",
    source: "Facebook review",
    pets: "Poppy, Nala, Indi & Frans",
    service: "Dog Walking",
    text: "Absolutely brilliant with my four dogs and really helped us out at short notice at a really difficult time. Carly is always happy to help and we will be seeking plenty more dogsitting services in the future! Thank you so much! Absolutely recommended!",
  },
  {
    id: "sam",
    client: "Sam Garrow",
    attribution: "Sam G, Inverness",
    relation: "Mabel, Mavis & Martha's Mum",
    source: "Facebook review",
    pets: "Mabel & Mavis",
    service: "Dog Walking",
    text: "couldn't ask for a better dog walker. The way Mabel and Mavis react when they see her says it all: tails wagging, happy dances, and pure excitement every single time. It's the best feeling knowing they're not just being walked, but genuinely cared for and loved.",
  },
  {
    id: "rachel",
    client: "Rachel",
    attribution: "Rachael M, Inverness",
    relation: "Luna's Mum",
    source: "Facebook review",
    pets: "Luna",
    service: "Dog Walking",
    text: "Absolutely fantastic service. So personal and tailored to our dog's needs and routines. Gives us peace of mind knowing Luna is so well looked after. The photo updates are a lovely touch.",
  },
  {
    id: "paul",
    client: "Paul McDonald",
    attribution: "Paul M, Inverness",
    relation: "Bruno's Dad",
    source: "Facebook review",
    pets: "Bruno",
    service: "Dog Walking",
    text: "Couldn't ask for a better dog walker! Bruno has come on so much since Carly started taking him out. He even walks much better for me now! Bruno definitely has the best time going out with Carly and meeting all his new pals.",
  },
  {
    id: "jonathan",
    client: "Jonathan",
    attribution: "Jonathan D, Inverness",
    relation: "Wilson's Dad",
    source: "Shared directly",
    pets: "Wilson",
    service: "Cats & Home Visits",
    text: "Since our dog is a little older and set in his ways, we asked Carly to visit him at our home. She accommodated his routine and updates us on his expeditions, keeping in touch, going above and beyond with photos and updates. When we got home it was as if we had never been gone. He was perfectly content. Having that peace of mind, that your four legged friend is loved and taken care of, allowed us to enjoy our trip even more. We will absolutely be requesting Carly's services again soon.",
  },
];
